import ExportButtonBlock from './ExportButtonBlock';
import ExportButton from './ExportButton';

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const bm = editor.BlockManager;
  const { labels, types, labelExportButtonCategory } = opts;
  ExportButtonBlock(bm, labelExportButtonCategory, labels.exportButton, types.exportButton);
  ExportButton(dc, labels.exportButton, types.exportButton, opts);
};
